import { InjectionToken } from '@angular/core';
import { SelectTranslationConfig } from '@agilox/common';

export const SELECT_TRANSLATION_CONFIG = new InjectionToken<SelectTranslationConfig>(
	'SELECT_TRANSLATION_CONFIG'
);
